import type {
  BelayUserConnection,
  PaginationLink,
  UserConnection,
  UserConnectionActionType
} from '@alltrails/types/belay';
import addActionsToUserConnection from './addActionsToUserConnection';

export const setUserActionRequestState = (
  { actions, ...userConnection }: UserConnection,
  actionKey: UserConnectionActionType,
  requestState: string
): UserConnection => ({
  ...userConnection,
  actions: { ...actions, [actionKey]: { ...actions[actionKey], requestState } }
});

export const addActionsToConnection = (belayUserConnection: BelayUserConnection): UserConnection =>
  addActionsToUserConnection(belayUserConnection);

export const addActionsToConnections = (connections: BelayUserConnection[]): UserConnection[] =>
  connections.map(addActionsToUserConnection);

export const getNextHref = (links: PaginationLink[]): string | null => {
  if (links) {
    const nextLink = links.find(link => link.rel === 'next');
    return nextLink ? nextLink.href : null;
  }
  return null;
};
